import { FC } from 'react';

import { Navigate, Outlet, useLocation } from 'react-router-dom';

import useCustomParams from '@/shared/hooks/useCustomParams';

export const DefaultPartnerRedirect: FC = () => {
	const { partner } = useCustomParams();
	const location = useLocation();

	if (process.env.DEFAULT_PARTNER === partner) {
		const pathname = location.pathname.replace(`/${process.env.DEFAULT_PARTNER}`, '') || '/';

		return <Navigate to={pathname.concat(location.search)} />;
	}

	return <Outlet />;
};
